import { authService } from '../../services/AuthService';
const state = {
    user: null,
    email: null,
    customer: null,
    token: localStorage.getItem('token'),
    isAuthenticated: !!localStorage.getItem('token'),
    isEmailVerified: false,
    loading: false,
    error: null,
};
const mutations = {
    SET_LOADING(state, loading) {
        state.loading = loading;
    },
    SET_USER(state, user) {
        state.user = user;
        state.isAuthenticated = !!user;
    },
    SET_EMAIL(state, email) {
        state.email = email;
        state.isEmailVerified = true;
    },
    SET_CUSTOMER(state, customer) {
        state.customer = customer;
        state.isAuthenticated = !!customer;
    },
    SET_TOKEN(state, token) {
        state.token = token;
        if (token) {
            localStorage.setItem('token', token);
        }
        else {
            localStorage.removeItem('token');
        }
    },
    SET_ERROR(state, error) {
        state.error = error;
    },
    LOGOUT(state) {
        state.user = null;
        state.token = null;
        state.isAuthenticated = false;
        localStorage.removeItem('token');
    },
};
const actions = {
    async login({ commit }, credentials) {
        try {
            commit('SET_LOADING', true);
            commit('SET_ERROR', null);
            const response = await authService.login(credentials);
            commit('SET_TOKEN', response.data.token);
            commit('SET_USER', response.data.user);
            return response;
        }
        catch (error) {
            commit('SET_ERROR', error.message || 'Login failed');
            throw error;
        }
        finally {
            commit('SET_LOADING', false);
        }
    },
    async checkAuth({ commit, state }) {
        const token = state.token || localStorage.getItem('token');
        if (!token) {
            return false;
        }
        //Restore token into Vuex if missing
        if (!state.token) {
            commit('SET_TOKEN', token);
        }
        try {
            const response = await authService.verifyToken();
            commit('SET_USER', response.data.user);
            return true;
        }
        catch (error) {
            commit('LOGOUT');
            return false;
        }
    },
    async register({ commit }, userData) {
        try {
            commit('SET_LOADING', true);
            commit('SET_ERROR', null);
            const response = await authService.signup(userData);
            return response;
        }
        catch (error) {
            commit('SET_ERROR', error.message || 'Registration failed');
            throw error;
        }
        finally {
            commit('SET_LOADING', false);
        }
    },
    async sendVerificationEmail({ commit }, payload) {
        try {
            commit('SET_LOADING', true);
            commit('SET_ERROR', null);
            // This should call your backend API to send verification mail
            const response = await authService.sendVerificationEmail(payload);
            return { ok: true, data: response.data };
        }
        catch (error) {
            commit('SET_ERROR', error.message || 'Failed to send verification link');
            return { ok: false, error: error.message };
        }
        finally {
            commit('SET_LOADING', false);
        }
    },
    async verifyEmail({ commit }, payload) {
        try {
            commit('SET_LOADING', true);
            commit('SET_ERROR', null);
            commit('SET_EMAIL', null);
            commit('SET_CUSTOMER', null);
            commit('SET_TOKEN', null);
            // Call backend API to verify email and get user + token
            const response = await authService.verifyEmail(payload);
            console.log('Verification response:', response.data.customer.id);
            if (response.data && response.data.success) {
                const { token } = response.data;
                // Store auth details like login
                commit('SET_TOKEN', token);
                commit('SET_EMAIL', response.data.customer.email);
                commit('SET_LOADING', false);
                commit('SET_CUSTOMER', response.data.customer.id);
                return { ok: true, data: response.data };
            }
            else {
                return {
                    ok: false,
                    error: response.data?.message || 'Verification failed',
                };
            }
        }
        catch (error) {
            commit('SET_ERROR', error.message || 'Email verification failed');
            return { ok: false, error: error.message };
        }
        finally {
            commit('SET_LOADING', false);
        }
    },
    logout({ commit }) {
        commit('LOGOUT');
    },
};
const getters = {
    isAuthenticated: (state) => state.isAuthenticated,
    isEmailVerified: (state) => state.isEmailVerified,
    email: (state) => state.email,
    user: (state) => state.user,
    customer: (state) => state.customer,
    token: (state) => state.token,
    loading: (state) => state.loading,
    error: (state) => state.error,
};
const auth = {
    state,
    mutations,
    actions,
    getters,
};
export default auth;
